import axios from 'axios';

const GetPackageRequests = () => {
	return axios.get(
		'https://backend.planmyleisure.com/package/get-all-requests'
	);
};

export default GetPackageRequests;
